import React from 'react';
import MapImage from 'oldAssets/images/static_pages/investment_locations/germany-map.webp';
import styles from './TopContent.module.scss';

const TopContent = ({ title, text }) => {
  return ( 
    <section className={ styles.TopContent }>
      <div className={ styles.content }>
        <figure>
          <img src={ MapImage } alt="map" />
        </figure>
        <article>
          <h3>{ title }</h3>
          <p>{ text }</p>
        </article>
      </div>
    </section>
  );
};
 
export default TopContent;